import { BlobCreate, type BlobLike } from "@pdfking/compatibility"
import type { AsyncSequence, Bytes } from "@pdfking/tfunc"

export const ResizeBlobs = async function* (
  blobs: AsyncSequence<BlobLike>,
  chunk_size: Bytes = (1024 * 1024 * 30) as Bytes
): AsyncGenerator<BlobLike> {
  let pending: ArrayBuffer[] = []
  let totalSize = 0

  for await (const blob of blobs) {
    let remaining = blob

    while (remaining.size > 0) {
      const spaceLeft = chunk_size - totalSize

      if (remaining.size <= spaceLeft) {
        // Fits in current chunk
        pending.push(await remaining.arrayBuffer())
        totalSize += remaining.size
        break
      }

      // Take only what fits in this chunk
      const slice = remaining.slice(0, spaceLeft)
      pending.push(await slice.arrayBuffer())
      totalSize += slice.size

      // Yield exact-size chunk
      yield BlobCreate(pending)

      // Reset and continue with leftover data
      pending = []
      totalSize = 0
      remaining = remaining.slice(spaceLeft)
    }

    if (totalSize === chunk_size) {
      yield BlobCreate(pending)
      pending = []
      totalSize = 0
    }
  }

  // Yield remainder
  if (pending.length > 0) {
    yield BlobCreate(pending)
  }
}
